/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Modal, Form, Button, FloatingLabel } from 'react-bootstrap';

export interface IKanbanMoveModal {
  type?: 'card' | 'list';
  show?: boolean;
  lists?: any[];
  listId: any;
  index: any;
  onHide?(): void;
  onSubmit(payload: any): void;
  moveModalTitle?: boolean;
}

export const KanbanMoveModal = (props: IKanbanMoveModal) => {
  const { type, show, lists = [] } = props;
  const [listId, setListId] = useState(props.listId ?? '');
  const [index, setIndex] = useState(props.index ?? 0);
  const cardList = lists.find((l) => l.id === listId);

  const onHide = () => {
    props.onHide && props.onHide();
  };

  const onSubmit = () => {
    const source = { droppableId: props.listId, index: props.index };
    const destination = { droppableId: listId, index };

    props.onSubmit && props.onSubmit({ source, destination });
  };

  return (
    <>
      <Modal as={Modal.Dialog} centered show={show} onHide={onHide}>
        <Form className="modal-content p-3">
          <Modal.Header className="pb-0 border-0">
            <Modal.Title className="fw-normal">
              {props.moveModalTitle}
            </Modal.Title>
            <Button variant="close" onClick={onHide} />
          </Modal.Header>
          <Modal.Body className="pb-0">
            {type === 'card' ? (
              <>
                <FloatingLabel id="listId" label="List" className="mb-3">
                  <Form.Select
                    value={listId}
                    onChange={(e) => setListId(e.target.value)}
                  >
                    {lists.map((l) => (
                      <option value={l.id} key={`move-list-id-${l.id}`}>
                        {l.id === props.listId
                          ? `${l.title} (current)`
                          : l.title}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
                {cardList && (
                  <FloatingLabel
                    id="listIndex"
                    label="Position"
                    className="mb-3"
                  >
                    <Form.Select
                      value={index}
                      onChange={(e) => setIndex(e.target.value)}
                    >
                      {cardList.cards.map((_: any, ind: number) => (
                        <option value={ind} key={`move-list-index-${ind}`}>
                          {ind + 1}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                )}
              </>
            ) : (
              <FloatingLabel id="listIndex" label="Position" className="mb-3">
                <Form.Select
                  value={index}
                  onChange={(e) => setIndex(e.target.value)}
                >
                  {lists.map((_, ind) => (
                    <option value={ind} key={`move-list-index-${ind}`}>
                      {ind === props.index ? `${ind + 1} (current)` : ind + 1}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            )}
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0 pt-0">
            <Button
              variant="secondary"
              className="d-inline-flex align-items-center"
              onClick={onSubmit}
            >
              {props.moveModalTitle}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

KanbanMoveModal.defaultProps = {
  type: 'card',
  show: false,
  lists: [],
  moveModalTitle: 'Move Attribute',
};
